import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {RegistroFuncionalidad, useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()

  const [data, setData] = useState<RegistroFuncionalidad[]>([])
  const {currentUser} = useAuth()

  useEffect(() => {
    if (currentUser?.registro.funcionalidad) {
      console.log('🔍 Ids disponibles:', currentUser.registro.funcionalidad.map(f => f.menu?.IdMenu))

      setData(currentUser.registro.funcionalidad)
    }
  }, [])

  function validarPorIdMenu(id: number) {
    return data.some((item) => item.menu !== null && item.menu.IdMenu === id)
  }

  const menuItems = [
    {
      ids: [5, 6, 47, 7, 42, 8, 9, 10, 11, 12, 13, 14, 48, 52],
      to: '/menu/catalogo',
      title: intl.formatMessage({id: 'MENU.CATALOGO'}),
      icon: '/media/icons/duotune/general/gen022.svg',
      subItems: [
        {id: 5, to: '/menu/catalogo/cars', title: intl.formatMessage({id: 'CATALOGO.CAR'})},
        {id: 11, to: '/menu/catalogo/usuarios', title: intl.formatMessage({id: 'CATALOGO.USERS'})},
        {id: 6, to: '/menu/catalogo/locales', title: intl.formatMessage({id: 'CATALOGO.LOCAL'})},

        {id: 92, to: '/menu/catalogo/categoria', title: 'Categoria'},
        // {id: 5, to: '/menu/catalogo/reclamaciones', title: 'Libro de Reclamaciones'},
        
        {
          id: 47,
          to: '/menu/catalogo/localxorgventas',
          title: intl.formatMessage({id: 'CATALOGO.LOCALXOV'}),
        },
        {id: 7, to: '/menu/catalogo/sociedad', title: intl.formatMessage({id: 'CATALOGO.SOCIETY'})},
        {
          id: 42,
          to: '/menu/catalogo/orgventas',
          title: intl.formatMessage({id: 'CATALOGO.ORGVENTAS'}),
        },
        {
          id: 8,
          to: '/menu/catalogo/clienteb2c',
          title: intl.formatMessage({id: 'CATALOGO.CLIENTEB2C'}),
        },
        {
          id: 9,
          to: '/menu/catalogo/clienteb2b',
          title: intl.formatMessage({id: 'CATALOGO.CLIENTEB2B'}),
        },
        {
          id: 10,
          to: '/menu/catalogo/empleados',
          title: intl.formatMessage({id: 'CATALOGO.EMPLOYEES'}),
        },

        // {
        //   id: 12,
        //   to: '/menu/catalogo/contactenos',
        //   title: intl.formatMessage({id: 'CATALOGO.CONTACTUS'}),
        // },
        {
          id: 13,
          to: '/menu/catalogo/esqestatus',
          title: intl.formatMessage({id: 'CATALOGO.STATUSSCHEME'}),
        },
        {
          id: 14,
          to: '/menu/catalogo/grpconsentimiento',
          title: intl.formatMessage({id: 'CATALOGO.GROUPCONSENT'}),
        },
        {id: 48, to: '/menu/catalogo/rol', title: intl.formatMessage({id: 'CATALOGO.ROLE'})},
        {
          id: 52,
          to: '/menu/catalogo/consentimiento',
          title: intl.formatMessage({id: 'CATALOGO.CONSENT'}),
        },
      ],
    },
    {
      ids: [70, 74, 75],
      to: '/menu/disponibilidades',
      // title: intl.formatMessage({id: 'MENU.TRANSACTIONS'}),
      title: 'Disponibidades',
      icon: '/media/icons/duotune/general/gen014.svg',
      subItems: [
        {
          id: 70,
          to: '/menu/disponibilidades/disponibilidad',
          // title: intl.formatMessage({id: 'TRANSACTIONS.BOOKING'}),
          title: 'Disponibilidad',
        },
        {
          id: 74,
          to: '/menu/disponibilidades/ficha',
          title: 'Ficha Registro',
        },
        {
          id: 75,
          to: '/menu/disponibilidades/calendario',
          title: 'Channel Manager',
        },
      ],
    },

    {
      ids: [15, 28],
      to: '/menu/transacciones',
      title: intl.formatMessage({id: 'MENU.TRANSACTIONS'}),
      icon: '/media/icons/duotune/general/gen016.svg',
      subItems: [
        {
          id: 15,
          to: '/menu/transacciones/reserva',
          title: intl.formatMessage({id: 'TRANSACTIONS.BOOKING'}),
        },
        {
          id: 28,
          to: '/menu/transacciones/cotizacion',
          title: intl.formatMessage({id: 'TRANSACTIONS.QUOTATION'}),
        },
      ],
    },

    {
      ids: [16, 17, 49],
      to: '/menu/configuracion',
      title: intl.formatMessage({id: 'MENU.CONFIG'}),
      icon: '/media/icons/duotune/general/gen019.svg',
      subItems: [
        {
          id: 16,
          to: '/menu/configuracion/especiftecnicas',
          title: intl.formatMessage({id: 'CONFIG.TECSPECIFIC'}),
        },
        {
          id: 17,
          to: '/menu/configuracion/constante',
          title: intl.formatMessage({id: 'CONFIG.CONSTANT'}),
        },
        {
          id: 49,
          to: '/menu/configuracion/componentefront',
          title: intl.formatMessage({id: 'CONFIG.COMPONT_FRONT'}),
        },
      ],
    },
    {
      ids: [12, 95],
      to: '/menu/administracion',
      title: 'Administración',
      icon: '/media/icons/duotune/general/gen024.svg',
      subItems: [
        {
          id: 12,
          to: '/menu/administracion/contactenos',
          title: 'Contactenos',
        },
        {
          id: 95,
          to: '/menu/administracion/reclamaciones',
          title: 'Libro Reclamaciones',
        },
      ],
    },
    {
      ids: [77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88],
      to: '/menu/facturacion',
      // title: intl.formatMessage({id: 'MENU.CONFIG'}),
      title: 'Facturación',
      icon: '/media/icons/duotune/general/gen005.svg',
      subItems: [
        {
          id: 77,
          to: '/menu/facturacion/moneda',
          title: 'Moneda',
        },
        {
          id: 78,
          to: '/menu/facturacion/categoriaigv',
          title: 'Categoría IGV',
        },
        {
          id: 79,
          to: '/menu/facturacion/tipocomprobante',
          title: 'Tipo Comprobante',
        },
        {
          id: 80,
          to: '/menu/facturacion/tipodocumento',
          title: 'Tipo Documento',
        },
        {
          id: 81,
          to: '/menu/facturacion/unidadmedida',
          title: 'Unidad Medida',
        },
        {
          id: 82,
          to: '/menu/facturacion/usuario',
          title: 'Usuario',
        },
        {
          id: 83,
          to: '/menu/facturacion/empresa',
          title: 'Empresa',
        },
        {
          id: 84,
          to: '/menu/facturacion/correlativo',
          title: 'Correlativo',
        },
        {
          id: 85,
          to: '/menu/facturacion/notacredito',
          title: 'Nota de Crédito',
        },
        {
          id: 86,
          to: '/menu/facturacion/boleta',
          title: 'Boleta',
        },
        {
          id: 87,
          to: '/menu/facturacion/factura',
          title: 'Factura',
        },
        {
          id: 88,
          to: '/menu/facturacion/codigonotacredito',
          title: 'Código Nota de Crédito',
        },
      ],
    },
    {
      ids: [90, 91],
      to: '/menu/ventas',
      title: 'Ventas',
      icon: '/media/icons/duotune/general/gen055.svg',
      subItems: [
        {
          id: 90,
          to: '/menu/ventas/cotizacion',
          title: 'Oferta de Venta',
        },
        {
          id: 91,
          to: '/menu/ventas/pedido',
          title: 'Pedido',
        },
      ],
    },
   
    // {
    //   ids: [90],
    //   to: '/menu/chat',
    //   title: 'Chat',
    //   icon:'/media/icons/duotune/communication/com012.svg',
    //   subItems: [
    //     {
    //       id: 90,
    //       to: '/menu/chat/private',
    //       title: 'Private',
    //     },
       
    //   ],
    // },
  ]

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'MENU.MENU'})}
          </span>
        </div>
      </div>

      {menuItems.map((menu) =>
        menu.ids.some(validarPorIdMenu) ? (
          <SidebarMenuItemWithSub
            key={menu.to}
            to={menu.to}
            title={menu.title}
            icon={menu.icon}
            fontIcon='bi-person'
          >
            <div className='overflow-auto' style={{maxHeight: '250px'}}>
              {menu.subItems.map(
                (subItem) =>
                  validarPorIdMenu(subItem.id) && (
                    <SidebarMenuItem
                      key={subItem.to}
                      to={subItem.to}
                      title={subItem.title}
                      hasBullet={true}
                    />
                  )
              )}
            </div>
          </SidebarMenuItemWithSub>
        ) : null
      )}
    </>
  )
}

export {SidebarMenuMain}
